import { TEXT } from '@/components/typography';
import { cn } from '@/lib/utils';

/**
 * The few pieces of markup the identity screens repeat: the row a native checkbox sits in, and the hints under
 * a field. Kept native on purpose — the role checklist's tests click the boxes by their label and read
 * `checked`/`disabled` straight off the input, and a phone keeps its own control. (The message box these
 * screens used to keep here is components/Notice.tsx now.)
 */

/**
 * The 44 px label row a native checkbox sits in; a disabled box greys its words with it. The words are a
 * checkbox label (TEXT.checkLabel, 14/500 on a 20 px line): a unit's name can run to two lines here, and each
 * line needs its own room for its diacritics. The row's height is the target, not the text's.
 */
export const CHECK_ROW = cn(
  'flex min-h-11 w-fit cursor-pointer items-center gap-2.5 text-[hsl(var(--h-card-foreground))]', TEXT.checkLabel,
  'has-[:disabled]:cursor-not-allowed has-[:disabled]:text-muted-foreground',
);

/** A hint under a checkbox row, indented to the row's words (1.25 rem box + 0.625 rem gap). */
export const CHECK_HINT = cn('pl-[1.875rem]', TEXT.hint);

/** A hint under a field. */
export const HINT = TEXT.hint;

/**
 * A role in the invitation's checklist, drawn like the mockup's scope options: a bordered card that takes the primary
 * border and a faint primary tint while ticked. Never a left bar.
 */
export const ROLE_OPTION = cn(
  'flex flex-col rounded-lg border border-[hsl(var(--h-border))] px-3 transition-colors',
  'has-[:checked]:border-[hsl(var(--h-primary))] has-[:checked]:bg-[hsl(var(--h-primary)/0.04)]',
);
